import { BaseRepository } from "@/repositories/base-repository"
import { type IRentalIntake } from "@/interfaces/api/rental-intake.interface"

export class RentalIntakeRepository extends BaseRepository<IRentalIntake> {
  protected resourcePath = "administration/rental-intakes"
}
